import React from 'react';

// hooks
import { usePosthogCapture } from 'eCoach/posthogCapture/chat';

// components
import DatesAndStatus from 'eCoach/allChats/DatesAndStatus';
import DeleteButton from 'eCoach/allChats/DeleteButton';
import Status from 'eCoach/allChats/Status';

// hooks
import { ECoachSession } from 'shared/hooks/api/ecoach';

// styles
import * as AllChats from 'eCoach/_styles/AllChats.style';
import * as Text from 'theme/components/Text.style';
import { Divider } from 'eCoach/_styles/Divider.style';

interface CardProps {
  chat: ECoachSession;
  index: number;
  getSession: (sessionId: string) => void;
  openDeleteModal: (e: React.MouseEvent, chat: ECoachSession) => void;
}

export default function Card({
  chat,
  index,
  getSession,
  openDeleteModal,
}: CardProps): JSX.Element {
  const chatCapture = usePosthogCapture();

  const clickSession = (pastSessionId: string): void => {
    getSession(pastSessionId);
    chatCapture.openedExistingChat();
  };

  return (
    <AllChats.ActiveConvosCard
      onClick={() => clickSession(chat.id)}
      className={`${
        index === 0
          ? 'demo-tour-step-9 demo-tour-step-10 onboarding-tour-step-7'
          : ''
      }`}
      id={`conversation-${chat.id}`}
      data-testid={`conversation-card-${index}`}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
        <div
          style={{
            display: 'flex',
            gap: '30px',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ maxWidth: '70ch' }}>
            <Text.P3>{chat.goal || chat.title}</Text.P3>
          </div>
          <DeleteButton chat={chat} openDeleteModal={openDeleteModal} />
        </div>
        <Divider />
      </div>
      <AllChats.BottomSection>
        <DatesAndStatus chat={chat} />
        {chat.resolution_status === 'active' && (
          <Status chat={chat} clickSession={clickSession} />
        )}
      </AllChats.BottomSection>
    </AllChats.ActiveConvosCard>
  );
}
